const ASSET_ORIGIN = "https://hzshixiang.site";
const CDN_JXUPLOAD = "https://img-cdn.hzshixiang.site/jxupload";
const ORIGIN_JXUPLOAD = "https://hzshixiang.site/jxupload";

/** 展示走 CDN，库内仍存源站地址 */
export function toCdnImageUrl(url) {
  const encoded = absReportAssetUrl(url);
  if (!encoded) return "";
  if (encoded.indexOf("http://hzshixiang.site/jxupload") === 0) {
    return CDN_JXUPLOAD + encoded.slice("http://hzshixiang.site/jxupload".length);
  }
  if (encoded.indexOf(ORIGIN_JXUPLOAD) === 0 && encoded.indexOf(CDN_JXUPLOAD) !== 0) {
    return CDN_JXUPLOAD + encoded.slice(ORIGIN_JXUPLOAD.length);
  }
  return encoded;
}

/** 文件名含空格、撇号等时须编码，否则 image 组件加载失败 */
export function encodeUrlPath(url) {
  if (url == null || url === "") return "";
  const m = String(url).match(/^(https?:\/\/[^/?#]+)(.*)$/i);
  if (!m) return encodeURI(url);
  const origin = m[1];
  const rest = m[2] || "";
  const qIndex = rest.indexOf("?");
  const hashIndex = rest.indexOf("#");
  let pathEnd = rest.length;
  if (qIndex >= 0) pathEnd = Math.min(pathEnd, qIndex);
  if (hashIndex >= 0) pathEnd = Math.min(pathEnd, hashIndex);
  const path = rest.slice(0, pathEnd);
  const tail = rest.slice(pathEnd);
  const encodedPath = path
    .split("/")
    .map((seg) => {
      if (!seg) return seg;
      let decoded = seg;
      try {
        decoded = decodeURIComponent(seg);
      } catch (e) {
        decoded = seg;
      }
      return encodeURIComponent(decoded).replace(/'/g, "%27");
    })
    .join("/");
  return origin + encodedPath + tail;
}

/** 补全相对路径、http→https，并编码路径段（型号图/谱图/实物图等） */
export function absReportAssetUrl(u, baseOrigin) {
  if (u == null || u === "") return "";
  let s = String(u).trim();
  if (!s || s === "null" || s === "undefined") return "";
  if (
    (s.startsWith('"') && s.endsWith('"')) ||
    (s.startsWith("'") && s.endsWith("'"))
  ) {
    s = s.slice(1, -1).trim();
  }
  if (!s || s === "null") return "";
  const base = baseOrigin || ASSET_ORIGIN;
  let url = "";
  if (/^https?:\/\//i.test(s)) {
    url = s.replace(/^http:\/\//i, "https://");
  } else if (s.startsWith("//")) {
    url = `https:${s}`;
  } else {
    url = s.startsWith("/") ? base + s : `${base}/${s}`;
  }
  return encodeUrlPath(url);
}

/** 与 absReportAssetUrl 同义，便于全局 $assetUrl 调用 */
export const assetUrl = absReportAssetUrl;

/** 从品牌/型号对象取图并编码（订单列表、后台队列等） */
export function pickBrandTypeImage(obj) {
  if (!obj) return "";
  const raw =
    obj.image ||
    obj.images ||
    obj.brandExampleImage ||
    obj.img ||
    obj.logo ||
    obj.icon ||
    obj.atlas1 ||
    obj.atlas2 ||
    obj.cover ||
    obj.pic ||
    obj.picture ||
    obj.photo ||
    "";
  return absReportAssetUrl(raw && String(raw).trim());
}

/** 订单项缩略图：型号图优先，其次品牌图 */
export function orderTypeThumb(item) {
  if (!item) return "";
  return (
    pickBrandTypeImage(item.type) ||
    pickBrandTypeImage(item.brand) ||
    ""
  );
}

/** JSON 数组 / 逗号分隔 / 单 URL → 首张图（已编码） */
export function firstImageUrl(images) {
  if (images == null || images === "") return "";
  let first = "";
  if (typeof images === "string") {
    const s = images.trim();
    if (!s) return "";
    if (s.startsWith("{") || s.startsWith("[")) {
      try {
        const parsed = JSON.parse(s);
        if (Array.isArray(parsed) && parsed.length) {
          first = parsed[0];
        } else if (parsed && typeof parsed === "object") {
          first = parsed.img || parsed.packImg || parsed.image || "";
        }
      } catch (e) {
        first = s.split(",")[0].trim();
      }
    } else if (s.indexOf(",") >= 0) {
      first = s.split(",")[0].trim();
    } else {
      first = s;
    }
  } else if (Array.isArray(images) && images.length) {
    first = images[0];
  } else if (images && typeof images === "object") {
    first = images.img || images.packImg || images.image || "";
  }
  return absReportAssetUrl(first);
}

/** URL 数组逐项编码 */
export function assetUrlList(urls) {
  if (!urls) return [];
  const arr = Array.isArray(urls) ? urls : [urls];
  return arr.map((u) => absReportAssetUrl(u)).filter(Boolean);
}



// WEBPACK FOOTER //
// ./src/util/reportAssetUrl.js